// Hooks
import { useAppDispatch } from '../../../app/hooks';

// Features
import { clearSession } from '../../../features/session/sessionSlice';

// Components
import SessionScreen from '../../organisms/SessionScreen/SessionScreen';
import SessionIdle from '../../molecules/SessionIdle/SessionIdle';
import Button from '../../atoms/Button/Button';
import Lead from '../../atoms/Lead/Lead';

// Styles
import styles from '../../molecules/SessionIdle/SessionIdle.module.css';

/**
 * @function SessionClosed
 * End of session user message
 *
 * @example
 * return (
 *   <SessionClosed />
 * )
 */
function SessionClosed(): JSX.Element {
    const dispatch = useAppDispatch();

    function handleLeaveClick(event: any) {
        dispatch(clearSession());
        event.preventDefault();
    }

    return (
        <SessionScreen>
            <SessionIdle heading="Session Closed">
                <Lead>
                    This session is now closed. Please return to the lobby to
                    join a new session.
                </Lead>
                <footer className={styles.footer}>
                    <Button text="Lobby" onClick={(e) => handleLeaveClick(e)} />
                </footer>
            </SessionIdle>
        </SessionScreen>
    );
}

// Exports
export default SessionClosed;
